export class QCDefectRequest{
    qcId : number;
    
    constructor(qcId : number)
    {
        this.qcId = qcId;
        
    }
}
